import { AppState } from '../states/app.state';
import { createSelector } from '@ngrx/store';
import { CommentsState } from '../states/comments.state';

const commentState = (state: AppState) => state.comments;

export const selectComments = createSelector(
    commentState,
    (state: CommentsState) => state.comments
);
